import React, { useCallback } from "react";
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import BlankLayout from "../../layouts/BlankLayout";
import LmsLaunchSetupView from "../../components/LmsLaunchSetupView/LmsLaunchSetupView";
import { useLmsLaunchSyncStatus } from "../../hooks/useLmsLaunchSyncStatus";
import type { RootStackParamList } from "../../navigation/navigation.types";

function LmsLaunchSetupContainer() {
  const route = useRoute<RouteProp<RootStackParamList, "LmsLaunchSetup">>();
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  const { syncJobId, redirectTo } = route.params;

  const handleComplete = useCallback(
    (target: string) => {
      const routeName = (target || "Home") as keyof RootStackParamList;
      navigation.reset({ index: 0, routes: [{ name: routeName }] });
    },
    [navigation]
  );

  const handleFailed = useCallback(() => {}, []);

  const { status, failedReason } = useLmsLaunchSyncStatus({
    jobId: syncJobId,
    redirectTo,
    onComplete: handleComplete,
    onFailed: handleFailed,
  });

  return (
    <BlankLayout>
      <LmsLaunchSetupView status={status} failedReason={failedReason} />
    </BlankLayout>
  );
}

export default LmsLaunchSetupContainer;
